import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table, Button, Tag } from "antd";
import Loader from "../util/Loader";
import "./Main.css";
import TopNav from "./TopNav";
import MainNav from "./MainNav";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import SelectCenter from "../util/SelectCenter";
import { useSelector, useDispatch } from "react-redux";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PopupComponent from "../util/ReservationPopup";
import moment from "moment";
import "moment/locale/ko";
import setup from "../setup";
import GetApiHost from "../util/GetApiHost";
import pr from "../util/pr";

const temp_columns = [
  {
    title: "시간",
    dataIndex: "value",
    key: "value",
  },
];

export default function ReservationBoard() {
  const [popupData, setPopupData] = useState({ seq: 0 });
  const [showPopup, setShowPopup] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [columns, setColumns] = useState(temp_columns);
  const [hourConfig, setHourConfig] = useState([]);
  const [pickDate, setPickDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const teacherRef = useRef([]);
  moment.locale("ko");

  const addDate = () => {
    setPickDate(moment(pickDate).add(1, "d"));
  };

  const subDate = () => {
    setPickDate(moment(pickDate).subtract(1, "d"));
  };

  const openReservationPopup = (target) => {
    var temp_cid = "";
    if (data.cid !== "root") {
      temp_cid = data.cid;
    } else {
      temp_cid = selectedCenter;
    }

    if (target.getAttribute("data-seq") === null) {
      return false;
    }

    setPopupData({
      seq: target.getAttribute("data-seq"),
      class_date: target.getAttribute("data-date"),
      class_hour_seq: target.getAttribute("data-hour"),
      final_state: target.getAttribute("data-state"),
      teacher: target.getAttribute("data-teacher"),
      name: target.getAttribute("data-name"),
      cid: temp_cid,
    });
  };

  useEffect(() => {
    if (popupData.seq !== 0) {
      setShowPopup(true);
    }
  }, [popupData]);

  const openReservationOnPopup = (tcd, name) => {
    var temp_cid = "";
    if (data.cid !== "root") {
      temp_cid = data.cid;
    } else {
      temp_cid = selectedCenter;
    }

    let url =
      "/reservationOnPopup?tcd=" +
      tcd +
      "&cid=" +
      temp_cid +
      "&name=" +
      name +
      "&date=" +
      moment(pickDate).format("YYYY-MM-DD");
    window.open(url, "_blank", "width=600, height=800, top=100, left=300");
  };

  function handleSelectedCenter(cid) {
    setSelectedCenter(cid);
  }

  function closePopup(isUpdated) {
    setShowPopup(false);
    if (isUpdated === "updated") {
      getTeacher();
      getTeacherOnData();
      getResData();
    }
  }

  function getHourData() {
    const host = GetApiHost();
    (async function () {
      const result = await axios.post(
        host + "/gympass_admin/get_hour_config",
        {}
      );
      setHourConfig(result.data.rows);
    })();
  }

  function getTeacher() {
    var temp_cid = "";
    if (data.cid !== "root") {
      temp_cid = data.cid;
    } else {
      temp_cid = selectedCenter;
    }

    (async function () {
      const host = GetApiHost();
      const result = await axios.post(
        host + "/gympass_admin/get_teacher_list",
        {
          cid: temp_cid,
        }
      );

      let teacherData = [];
      if (result.data.rows) {
        teacherData = result.data.rows;
      }
      let newColumns = temp_columns;
      teacherData.map((item, index) => {
        // let y = index;
        newColumns = newColumns.concat({
          title: () => (
            <div className="table-center bold">
              {item.teacher}
              <button
                className="title-btn ant-btn"
                onClick={() => openReservationOnPopup(item.tcd, item.teacher)}
              >
                근무시간 등록
              </button>
            </div>
          ),
          dataIndex: "seq",
          key: "seq",
          render: (x) => {
            let arr = [x, item.tcd];
            return (
              <div
                ref={(el) => (teacherRef.current[arr] = el)}
                className="table-center"
                onClick={(e) => openReservationPopup(e.target)}
              ></div>
            );
          },
        });
      });
      setColumns(newColumns);

      getHourData();
    })();
  }

  const getResData = async () => {
    var temp_cid = "";
    if (data.cid !== "root") {
      temp_cid = data.cid;
    } else {
      temp_cid = selectedCenter;
    }

    const host = GetApiHost();
    const result = await axios.post(
      host + "/gympass_admin/get_reservation_board_list",
      {
        cid: temp_cid,
        date: moment(pickDate).format("YYYY-MM-DD"),
      }
    );

    let temp_data = [];
    if (result.data.rows) {
      temp_data = result.data.rows;
    }

    // 예약 데이타 넣기
    // reserved 를 추가해서 클리어
    temp_data.map((resItem, i) => {
      const { class_hour_seq, tcd, count } = resItem;
      let arr = [class_hour_seq, tcd];

      if (teacherRef.current[arr]) {
        teacherRef.current[arr].parentNode.classList.add("reserved");
        teacherRef.current[arr].innerHTML =
          '<span style="border:1px solid gray; min-width:20px; display:inline-block">' +
          count +
          "</span>";
          teacherRef.current[arr].setAttribute("data-seq", class_hour_seq);
      }
    });

    /*
    

    // 예약 겨져오기
    (async function () {
      const host = GetApiHost();
      const result = await axios.post(
        host + "/gympass_admin/get_reservation_board_list",
        {
          cid: temp_cid,
          date: moment(pickDate).format("YYYY-MM-DD"),
        }
      );

      let temp_data = [];
      if (result.data.rows) {
        temp_data = result.data.rows;
      }      
      
      temp_data.map((resItem, i) => {
        const {
          class_hour_seq,
          tcd,
          count,
        } = resItem;        
        let arr = [class_hour_seq, tcd];

        // let color = "";
        // if (final_state === "예약완료") {
        //   color = "blue";
        // } else if (final_state === "평가요청") {
        //   color = "red";
        // } else if (final_state === "평가완료") {
        //   color = "green";
        // } else if (final_state === "결석") {
        //   color = "gray";
        // } else if (final_state === "노쇼") {
        //   color = "purple";
        // }        

        if (teacherRef.current[arr]) {
            teacherRef.current[arr].innerHTML='<span style="border:1px solid gray; min-width:20px; display:inline-block">'+count+'</span>';

        //   teacherRef.current[arr].parentNode.classList.add("reserved");
        //   teacherRef.current[arr].innerHTML =
        //     name +
        //     "<span class='ant-tag ant-tag-" +
        //     color +
        //     "'>" +
        //     final_state +
        //     " </span>";
        //   teacherRef.current[arr].setAttribute("data-seq", seq);
        //   teacherRef.current[arr].setAttribute("data-date", class_date);
        //   teacherRef.current[arr].setAttribute("data-hour", class_hour_seq);
        //   teacherRef.current[arr].setAttribute("data-state", final_state);
        //   teacherRef.current[arr].setAttribute("data-teacher", teacher);
        //   teacherRef.current[arr].setAttribute("data-name", name);
        }
      });

    })();
    */
  };

  function getTeacherOnData() {
    var temp_cid = "";
    if (data.cid !== "root") {
      temp_cid = data.cid;
    } else {
      temp_cid = selectedCenter;
    }
    
    // 컨텐츠 리셋
    let res_el = document.getElementsByClassName("reserved");
    for (var i = 0; i < res_el.length; i++) {
      res_el[i].childNodes[0].innerHTML = "";
    }

    // 클래스 리셋
    let el = document.getElementsByClassName("ant-table-cell");
    for (var i = 0; i < el.length; i++) {
      el[i].classList.remove("on");
      el[i].classList.remove("reserved");
    }
    let teacherOnData = [];
    (async function () {
      const host = GetApiHost();
      const result = await axios.post(
        host + "/gympass_admin/get_teacher_on_list_1",
        {
          cid: temp_cid,
          date: moment(pickDate).format("YYYY-MM-DD"),
        }
      );
      let temp_data = [];
      if (result.data.rows) {
        temp_data = result.data.rows;
        temp_data.map((item, i) => {
          (async function () {
            let result2 = await axios.post(
              host + "/gympass_admin/get_teacher_on_list_2",
              {
                tcd: item.tcd,
                start_time_cd: item.start_time_cd,
                end_time_cd: item.end_time_cd,
              }
            );
            if (result2.data.rows) {
              let arr = result2.data.rows;
              arr.map((arrItem, idx) => {
                teacherOnData = teacherOnData.concat({
                  seq: arrItem.seq,
                  tcd: arrItem.tcd,
                });
              });
            }
            
            // 예약 가능 시간
            teacherOnData.map((onItem, j) => {
              const { seq, tcd } = onItem;
              let arr = [seq, tcd];
              if (teacherRef.current[arr]) {
                teacherRef.current[arr].parentNode.classList.add("on");
              }
            });

          })();
        });
      }
    })();
  }

  async function main() {
    const result = await LoginCheck(data.url);
    if (result === "Y") {
      const decodeResult = await DecodeData(data.url);
      dispatch({ type: "SET", name: "CID", value: decodeResult.cid });
      dispatch({ type: "SET", name: "LEVEL", value: decodeResult.level });
      getTeacher();
      getTeacherOnData();
      getResData();
      setInterval(() => {
        setIsLoading(false);
      }, 300);
    } else {
      LoginFail();
    }
  }

  useEffect(() => {
    main();
  }, []);

  useEffect(() => {
    getTeacherOnData();
    getResData();
  }, [isLoading]);

  useEffect(() => {
    if (data.cid === "root") {
      getTeacher();
      getTeacherOnData();
      getResData();
    }
  }, [selectedCenter]);

  useEffect(() => {
    getTeacher();
    getTeacherOnData();
    getResData();
  }, [pickDate]);

  if (isLoading)
    return (
      <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
          <MainNav />
          <Loader />
        </div>
      </main>
    );

  return (
    <main className="main-container">
      <TopNav />
      <div className="content-wrapper">
        <MainNav />
        <div className="content-inner">
          <h3>예약보드</h3>
          
          <Button size="small" disabled={true}>예약보드</Button> <Button size="small" onClick={()=>window.location.href='/reservation'}>예약관리</Button>

          <div className="content-component">
            <div className="content-header">
              <div></div>
              <SelectCenter onSelectedCenter={handleSelectedCenter} />
            </div>
            <div className="content-body">
              <div className="day-range">
                <a href="#">
                  <Button
                    className="mr-1 btn-secondary"
                    size="sm"
                    onClick={subDate}
                  >
                    <FontAwesomeIcon icon={faAngleLeft} />
                  </Button>
                </a>
                {moment(pickDate).format("YYYY년 MM월 DD일 (ddd)")}
                <a href="#">
                  <Button
                    className="ml-1 btn-secondary"
                    size="sm"
                    onClick={addDate}
                  >
                    <FontAwesomeIcon icon={faAngleRight} />
                  </Button>
                </a>
              </div>
              <div className="table-body cursor board">
                <Table
                  dataSource={hourConfig}
                  columns={columns}
                  pagination={false}
                  rowKey="seq"
                />
              </div>
            </div>
          </div>
          {showPopup ? (
            <PopupComponent
              data={popupData}
              mode="board"
              closePopup={closePopup}
            />
          ) : null}
        </div>
      </div>
    </main>
  );
}
